/**
 * x_tarificador-cart-rates-cart.js
 * Manejo de eventos y lógica del selector de tarifas en el carrito
 */
(function() {
  'use strict';
  
  window.HACIENDOLA = window.HACIENDOLA || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS || {};
  
  /**
   * Maneja el cambio de provincia en el selector del carrito
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.provinceSelectChange = () => {
    const provinceSelect = document.getElementById('pscCartDropdownProvinceSelect');
    const citySelect = document.getElementById('pscCartDropdownCitySelect');
    if (!provinceSelect || !citySelect) return;

    const selectedProvinceCode = provinceSelect.value;

    const pscCartDropdownRatesPreviewWrapper = document.getElementById('pscCartDropdownRatesPreviewWrapper');
    if (pscCartDropdownRatesPreviewWrapper) {
      pscCartDropdownRatesPreviewWrapper.innerHTML = '';
    }

    citySelect.innerHTML = '<option value="0">' + window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['CHOOSE CITY TEXT'] + '</option>';
    
    if (selectedProvinceCode === '0') {
      citySelect.classList.add('hidden');
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.saveSelection();
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.syncSelectors('cart', null, null);
      
      document.dispatchEvent(new CustomEvent('shipping:location:changed', {
        detail: { province: null, city: null }
      }));
      return;
    }

    const selectedProvince = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.provincesWithCities.find(
      (x) => x.provinceCode == selectedProvinceCode
    );
    
    if (!selectedProvince) return;

    let htmlCities = '<option value="0">' + window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['CHOOSE CITY TEXT'] + '</option>';
    selectedProvince.provinceCities.forEach(
      (x) => (htmlCities += '<option value="' + x.cityName + '">' + x.cityName + '</option>')
    );
    citySelect.innerHTML = htmlCities;
    citySelect.classList.remove('hidden');

    window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
    window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.saveSelection();
    window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.syncSelectors('cart', selectedProvinceCode, null);
    
    document.dispatchEvent(new CustomEvent('shipping:location:changed', {
      detail: { province: selectedProvinceCode, city: null }
    }));
  };

  /**
   * Maneja el cambio de ciudad en el selector del carrito y calcula tarifas
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.citySelectChange = () => {
    const provinceSelect = document.getElementById('pscCartDropdownProvinceSelect');
    const citySelect = document.getElementById('pscCartDropdownCitySelect');
    const pscCartDropdownRatesPreviewWrapper = document.getElementById('pscCartDropdownRatesPreviewWrapper');
    
    if (!provinceSelect || !citySelect || !pscCartDropdownRatesPreviewWrapper) return;
    
    const provinceCode = provinceSelect.options[provinceSelect.selectedIndex].value;
    const cityName = citySelect.options[citySelect.selectedIndex].text;
    
    window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.saveSelection();
    window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
    window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.syncSelectors('cart', provinceCode, cityName);

    document.dispatchEvent(new CustomEvent('shipping:location:changed', {
      detail: { province: provinceCode, city: cityName }
    }));

    pscCartDropdownRatesPreviewWrapper.innerHTML = `<p style="color:#000;">${window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['CALCULATING RATES']}</p>`;
    
    fetch(
      `/cart/shipping_rates.json?shipping_address[country]=${window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['SHIPPING COUNTRY']}&shipping_address[province]=${provinceCode}&shipping_address[city]=${cityName}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.error) {
          pscCartDropdownRatesPreviewWrapper.innerHTML =
            '<p style="margin: 0; font-weight: bold;">' + res.error[0] + '</p>';
          return;
        }
        
        const rates = res.shipping_rates;
        let finalHtml = '';
        
        if (rates.length === 0) {
          pscCartDropdownRatesPreviewWrapper.innerHTML = `<p style="color:#000;">${window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['NO RATES AVAILABLE']}</p>`;
        } else {
          finalHtml = '<p style="margin: 0; font-weight: bold; text-align: left !important;">'+ window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['AVAILABLE RATES'] +'</p>';
          
          rates.forEach((rate) => {
            const ignored = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.ignoredRatesCode.findIndex((x) => x === rate.code) !== -1;
            if (!ignored) {
              finalHtml += `
                <div style="display: flex; justify-content: space-between;">
                  <p style="margin:0">${rate.name}</p>
                  <p style="margin:0">$${window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.numberformat(rate.price)}</p>
                </div>
              `;
            }
          });
          pscCartDropdownRatesPreviewWrapper.innerHTML = finalHtml;
        }
        
        document.dispatchEvent(new CustomEvent('shipping:rates:updated', {
          detail: { 
            rates: rates, 
            province: provinceCode, 
            city: cityName 
          }
        }));
      })
      .catch(err => console.error('Error fetching rates:', err));
  };

  /**
   * Configura los event listeners del carrito
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.setupCartListeners = (provinceSelect, citySelect, provinces, savedSelection) => {
    const htmlRegions = provinces.reduce(
      (acc, region) =>
        acc + '<option value="' + region.provinceCode + '">' + region.provinceName + '</option>',
      '<option value="0">'+ window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['CHOOSE PROVINCE TEXT'] +'</option>'
    );

    provinceSelect.innerHTML = htmlRegions;
    provinceSelect.classList.remove('hidden');
    
    // Restaurar provincia seleccionada desde localStorage
    if (savedSelection.province && savedSelection.province !== '0') {
      provinceSelect.value = savedSelection.province;
    }
    
    // Remover listeners previos
    provinceSelect.removeEventListener('change', window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.provinceSelectChange);
    citySelect.removeEventListener('change', window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.citySelectChange);
    
    if (provinces.length === 1) {
      provinceSelect.value = provinces[0].provinceCode;
      provinceSelect.disabled = true;
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.provinceSelectChange();
    } else {
      provinceSelect.addEventListener('change', window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.provinceSelectChange);
    }

    // Si había una provincia seleccionada, cargar las ciudades
    if (provinceSelect.value && provinceSelect.value !== '0') {
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.provinceSelectChange();
      
      // Restaurar ciudad seleccionada después de un pequeño delay
      setTimeout(() => {
        if (savedSelection.city) {
          const citySelect = document.getElementById('pscCartDropdownCitySelect');
          if (citySelect) {
            for (let i = 0; i < citySelect.options.length; i++) {
              if (citySelect.options[i].text === savedSelection.city) {
                citySelect.selectedIndex = i;
                citySelect.value = citySelect.options[i].value;
                
                if (window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.showRates) {
                  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.citySelectChange();
                }
                break;
              }
            }
          }
        }
        
        window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
      }, 300);
    } else {
      window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.updateHeaderButton();
    }

    if(window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.showRates) {
      citySelect.addEventListener('change', window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.citySelectChange);
    }

    // Setup checkout buttons
    setTimeout(() => {
      const checkoutButtons = document.getElementsByName(window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.goToCheckoutButtonName);
      checkoutButtons.forEach(btn => {
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
        
        newBtn.addEventListener('click', (event) => {
          const citySelect = document.getElementById('pscCartDropdownCitySelect');
          const provinceSelect = document.getElementById('pscCartDropdownProvinceSelect');
          if (!citySelect || !provinceSelect) return;
          
          if (citySelect.selectedIndex === 0 && window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.forceCitySelection) {
            event.stopPropagation();
            event.preventDefault();
            alert(window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['FORCE SELECTION MESSAGE']);
            return false;
          }
          
          if (citySelect.selectedIndex > 0) {
            const selectedCityText = citySelect.options[citySelect.selectedIndex].text;
            const selectedProvinceCode = provinceSelect.options[provinceSelect.selectedIndex].value;
            const form = document.getElementById(window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.cartCheckoutFormId);
            if (form) {
              form.action = `/cart?checkout[shipping_address][country]=${window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['SHIPPING COUNTRY']}&checkout[shipping_address][province]=${selectedProvinceCode}&checkout[shipping_address][city]=${selectedCityText}`;
            }
          }
        });
      });
    }, 100);

    // Set title
    const title = document.getElementById('pscCartDropdownTitle');
    if (title) {
      title.innerHTML = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues['SNIPPET TITLE'];
    }
  };
})();